import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/nplogo.png'
import _imports_1 from '../assets/video/bg1.jpg'
import _imports_2 from '../assets/video/bg1.webm'
import _imports_3 from '../assets/video/bg1.ogg'
import _imports_4 from '../assets/video/bg1.mp4'
import _imports_5 from '../assets/images/SPSF_web.png'


const _withScopeId = n => (_pushScopeId("data-v-11d5d616"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"ParallaxImage bg-top d-block d-md-none\" data-v-11d5d616><div class=\"text-center\" data-v-11d5d616><img src=\"" + _imports_0 + "\" width=\"300\" data-v-11d5d616></div></div><div class=\"ParallaxVideo d-none d-md-block\" data-v-11d5d616><video autoplay muted loop poster=\"" + _imports_1 + "\" class=\"d-none d-md-block\" data-v-11d5d616><source src=\"" + _imports_2 + "\" type=\"video/webm\" data-v-11d5d616><source src=\"" + _imports_3 + "\" type=\"video/ogg\" data-v-11d5d616><source src=\"" + _imports_4 + "\" type=\"video/mp4\" data-v-11d5d616></video><div class=\"text-center\" data-v-11d5d616><img src=\"" + _imports_0 + "\" data-v-11d5d616></div></div>", 2)
const _hoisted_5 = { class: "ParallaxContent" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row row-cols-1 row-cols-md-3 g-4" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "card h-100 text-center" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Skriv för NP", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, " Nationellt Pistolskytte söker alltid medarbetare som kan skriva för tidningen. ", -1))
const _hoisted_13 = { class: "card-footer" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, "Skriv för NP", -1))
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "card h-100 text-center" }
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Annonsera i NP", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, " I Nationellt Pistolskytte når du ut till ca. 30.000 läsare med en annons. ", -1))
const _hoisted_20 = { class: "card-footer" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, "Annonsera", -1))
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "card h-100 text-center" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Tipsa oss!", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, " Vi behöver ständigt era tips för att göra en bra tidning. ", -1))
const _hoisted_27 = { class: "card-footer" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, "Tipsa oss", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ParallaxImage bg-fronts" }, null, -1))
const _hoisted_30 = { class: "ParallaxContent" }
const _hoisted_31 = { class: "container" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "headlines" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Om Nationellt Pistolskytte")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Nationellt Pistolskytte (NP) är Svenska Pistolskytteförbundets medlemstidning. Den är Sveriges största (och enligt mångas uppfattning bästa) skyttetidning med en upplaga på drygt 22.000 exemplar. Tidningen (som kommer ut med fyra nummer per år) har karaktär av medlemstidning och går ut till alla som rapporterats som aktiva medlemmar. ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Den som inte är aktiv medlem men ändå vill ha tidningen kan prenumerera genom att kontakta "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:kansliet@pistolskytteforbundet.se" }, "Förbundskansliet"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Tidningens redaktionella innehåll består till största del av reportage från tävlingar, personintervjuer, artiklar om utrustning, föreningsliv och innovativa lösningar för alla de 481 föreningar som är anslutna till Svenska Pistolskytteförbundet. Över 20 000 aktiva medlemmar får tidningen skickad till sig fyra gånger per år. ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Redaktionen är också tacksam för uppslag och artiklar från läsekretsen. Kontakta någon av tidningens redaktörer på "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:np@liteolika.se" }, "np@liteolika.se"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"ParallaxImage bg3\" data-v-11d5d616><div class=\"container\" data-v-11d5d616><div class=\"row\" data-v-11d5d616><div class=\"col-sm-2\" data-v-11d5d616><img src=\"" + _imports_5 + "\" height=\"100\" data-v-11d5d616></div><div class=\"col-sm-10\" style=\"color:white;\" data-v-11d5d616><p data-v-11d5d616> Nationellt Pistolskytte är Svenska Pistolskytteförbundets medlemstidning.<br data-v-11d5d616> Redaktionsarbetet för Nationellt Pistolskytte utförs av Liteolika Mediaproduktion AB.<br data-v-11d5d616> Ansvarig utgivare för sajten nationelltpistolskytte.se är Peter Stålbrand. </p><p data-v-11d5d616> © 2020, Liteolika Mediaproduktion AB<br data-v-11d5d616></p></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_fa, {
                    icon: "pen",
                    class: "card-icon"
                  }),
                  _hoisted_11,
                  _hoisted_12
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: "/write",
                    class: "card-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_fa, {
                    icon: "ad",
                    class: "card-icon"
                  }),
                  _hoisted_18,
                  _hoisted_19
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    to: "/advertisement",
                    class: "card-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_fa, {
                    icon: "lightbulb",
                    class: "card-icon"
                  }),
                  _hoisted_25,
                  _hoisted_26
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_router_link, {
                    to: "/tips",
                    class: "card-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _hoisted_33,
          _hoisted_34,
          _hoisted_35,
          _createElementVNode("p", null, [
            _createTextVNode(" Vill du annonsera i tidningen? "),
            _createVNode(_component_router_link, { to: "/annonsera" }, {
              default: _withCtx(() => [
                _createTextVNode("Kontakta då oss")
              ]),
              _: 1
            }),
            _createTextVNode(" för en prisuppgifter, offert eller mer information. ")
          ]),
          _hoisted_36
        ])
      ]),
      _hoisted_37
    ])
  ]))
}